/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FaturasAliases {
  CONTEXTUAL_BAR = 'contextual-bar',
  DATE_FIELD_DT_FIM = 'date-field-dt-fim',
  DATE_FIELD_DT_INICIO = 'date-field-dt-inicio',
  DECK_FATURAS = 'deck-faturas',
  FETCH_FATURAS = 'fetch-faturas',
  FIELD_DT_FIM = 'field-dt-fim',
  FIELD_DT_INICIO = 'field-dt-inicio',
  FIELD_DT_VENCIMENTO = 'field-dt-vencimento',
  FIELD_NM_PAGADOR = 'field-nm-pagador',
  FIELD_NR_NOTA_FISCAL = 'field-nr-nota-fiscal',
  FIELD_NR_TITULO = 'field-nr-titulo',
  FIELD_VL_FATURA = 'field-vl-fatura',
  FILTER_FATURAS = 'filter-faturas',
  FILTERED_LIST = 'filtered-list',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_DYNAMIC_CONTENT_FIELD_SITUACAO = 'hpms-dynamic-content-field-situacao',
  PANEL_MAIN = 'panel-main',
  TEXT_DT_VENCIMENTO = 'text-dt-vencimento',
  TEXT_NM_PAGADOR = 'text-nm-pagador',
  TEXT_NR_NOTA_FISCAL = 'text-nr-nota-fiscal',
  TEXT_NR_TITULO = 'text-nr-titulo',
  TEXT_VL_FATURA = 'text-vl-fatura',
}
export { FaturasAliases };
